import { CalculateVenueEnv } from '@/domain/impact-calculate-venue/entities/calculate-venue-env.entity';

/**
 * For some reason the intensity was required by Maxime in the PDF generation
 * here is the selector that will biject the extended version of the ESS
 */
export const extendVenueEnvCalculate = (initialState: CalculateVenueEnv) => {
  // workaround to avoid the readonly Redux state
  const env = JSON.parse(JSON.stringify(initialState)) as CalculateVenueEnv;
  env.structure.topics.RESOURCES_POLLUTION.score =
    env.structure.topics.RESOURCES_POLLUTION.score + env.dates.score;

  env.structure.topics.RESOURCES_POLLUTION.maxScore =
    env.structure.topics.RESOURCES_POLLUTION.maxScore + env.dates.maxScore;

  env.structure.topics.RESOURCES_POLLUTION.sections.INTENSITY = {
    score: env.dates?.score || 0,
    maxScore: env.dates?.maxScore || 9,
  };
  return env;
};
